import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  saveTachographSetting,
  getTachographSettingByVehicleId,
  type TachographSettingPayload,
} from "src/services/tachographSettingsService";
import { useGeneralRefetchOverride } from "./general.queries";
import { QueryNames } from "./queries.constant";

type SaveTachographSettingParams = {
  vehicleId: string | number;
  payload: TachographSettingPayload;
};

export const useQueryGetTachographSetting = (vehicleId?: string | number, options: { refetchInterval?: number | false } = {}) => {
  const enabled = !!vehicleId;

  return useGeneralRefetchOverride(
    useQuery({
      queryKey: [...QueryNames.tachographSettings, vehicleId],
      queryFn: () => getTachographSettingByVehicleId(vehicleId as string | number),
      enabled,
      retry: false,
      ...options,
    }),
    enabled
  );
};

export const useMutationSaveTachographSetting = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ vehicleId, payload }: SaveTachographSettingParams) =>
      saveTachographSetting(vehicleId, payload),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: QueryNames.tachographSettings,
      }),
  });
};
